import { services } from '@octadesk-tech/services'
import Storage from '@octadesk-tech/storage'
import { getParameterHeaders } from './headers'

export const getForm = async formId => {
  const headers = getParameterHeaders()

  const cacheKey = `chat:forms:${headers.AppSubdomain}:${formId}`

  const form = Storage.getItem(cacheKey)

  if (form) {
    return form
  }

  const client = await services.createClient('forms')

  const response = await client.get(`render/${formId}/chat`, {
    headers: getParameterHeaders()
  })

  if (response.data) {
    Storage.setItem(cacheKey, response.data, 3600)
  }

  return response.data
}
